/** Recuperado del despliegue 2026-10-05. Conserva lógica y memoización originales. */
import {
  rec_JSXRuntime as JSXRuntime,
  rec_Lo as Lo,
  rec_React as React,
  rec_ReactCompiler as ReactCompiler,
  rec_Ro as Ro,
  rec_Ti as Ti,
  rec_api as api,
} from "../../runtime/index.jsx";
export function NuevaLista(e) {
  let t = (0, ReactCompiler.c)(12),
    { proyectoId: n, onCreada: r, onError: i } = e,
    [a, o] = (0, React.useState)(``),
    s;
  t[0] !== a || t[1] !== r || t[2] !== i || t[3] !== n
    ? ((s = async function (e) {
        if ((e.preventDefault(), a.trim()))
          try {
            (await api(`/listas`, {
              method: `POST`,
              body: JSON.stringify({
                proyectoId: n,
                nombre: a,
              }),
            }),
              o(``),
              r());
          } catch (e) {
            i(e.message);
          }
      }),
      (t[0] = a),
      (t[1] = r),
      (t[2] = i),
      (t[3] = n),
      (t[4] = s))
    : (s = t[4]);
  let c = s,
    l;
  t[5] === Symbol.for(`react.memo_cache_sentinel`)
    ? ((l = (e) => o(e.target.value)), (t[5] = l))
    : (l = t[5]);
  let u;
  t[6] === a
    ? (u = t[7])
    : ((u = (
        <input
          className={Lo}
          placeholder={`Nombre de la lista`}
          value={a}
          onChange={l}
        />
      )),
      (t[6] = a),
      (t[7] = u));
  let f;
  t[8] === Symbol.for(`react.memo_cache_sentinel`)
    ? ((f = (
        <button
          type={`submit`}
          className={Ro}
          children={<Ti className={`inline h-4 w-4`} />}
        />
      )),
      (t[8] = f))
    : (f = t[8]);
  let p;
  return (
    t[9] !== c || t[10] !== u
      ? ((p = <form onSubmit={c} className={`flex gap-2`} children={[u, f]} />),
        (t[9] = c),
        (t[10] = u),
        (t[11] = p))
      : (p = t[11]),
    p
  );
}
